( function ( $ ) {

    function show_my_videos( data ) {
        var html = [ '<ul id="videos">' ];
        $( data.items ).each( function ( index, item ) {
            var desc = item.title,
                videoId = item.snippet.resourceId.videoId;
            // append HTML
            html.push( '<div class="video-item"><div class="video-wrapper"><iframe src="https://www.youtube.com/embed/' + videoId + '?modestbranding=1&amp;rel=0&amp;autoplay=0"></iframe></div></div>' );
        } );
        $( "#videos" ).html( html.join( '' ) );
    }

    $( document ).ready( function () {
        var url = "";
        if ( $( window ).width() <= 767 ) {
            url = "https://www.googleapis.com/youtube/v3/playlistItems?part=snippet%2CcontentDetails&maxResults=3&playlistId=UUgYcYrbOX0jwf996MhI3IAg&key=AIzaSyC2HxgNEMQXN0d87J0-F5plqQCPZieMPKs";
        } else {
            url = "https://www.googleapis.com/youtube/v3/playlistItems?part=snippet%2CcontentDetails&maxResults=12&playlistId=UUgYcYrbOX0jwf996MhI3IAg&key=AIzaSyC2HxgNEMQXN0d87J0-F5plqQCPZieMPKs";
        }
        $.ajax( {
            url: url,
            dataType: "jsonp",
            success: function ( data ) {
                show_my_videos( data );
            }
        } );
    } );

} )( jQuery );